/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface FindResourceHandlerPayload
 */

/**
 * Check if a given object implements the FindResourceHandlerPayload interface.
 */
export function instanceOfFindResourceHandlerPayload(value) {
  if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
  return true;
}
export function FindResourceHandlerPayloadFromJSON(json) {
  return FindResourceHandlerPayloadFromJSONTyped(json, false);
}
export function FindResourceHandlerPayloadFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'resourceType': json['resourceType'],
    'metadata': json['metadata'] == null ? undefined : json['metadata']
  };
}
export function FindResourceHandlerPayloadToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'resourceType': value['resourceType'],
    'metadata': value['metadata']
  };
}